import { useEffect, useRef } from "react";
import { CloseButton, Message, Toast } from "./styles";
import { ToastFeedbackProps } from "./types";

export function ToastFeedback({
  message,
  type,
  isOpen,
  duration = 3000,
  onClose,
}: ToastFeedbackProps) {
  const onCloseRef = useRef(onClose);

  useEffect(() => {
    onCloseRef.current = onClose;
  }, [onClose]);

  useEffect(() => {
    if (!isOpen || duration <= 0) return undefined;

    const timeout = window.setTimeout(() => onCloseRef.current(), duration);
    return () => window.clearTimeout(timeout);
  }, [duration, isOpen, message, type]);

  if (!isOpen) return null;

  return (
    <Toast
      $type={type}
      role={type === "error" ? "alert" : "status"}
      aria-live={type === "error" ? "assertive" : "polite"}
    >
      <Message>{message}</Message>
      <CloseButton type="button" onClick={onClose} aria-label="Fechar mensagem">
        ×
      </CloseButton>
    </Toast>
  );
}

export type { ToastFeedbackProps, ToastFeedbackType } from "./types";
